// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Printer from "@insite/mobius/Icons/Printer";
import dataTableStyles from "@steiner/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { openBidsStyles } from "@steiner/App/Widgets/OpenBids/HomeOpenBids";
import { hideElementOnPrint, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

openBidsStyles.notFoundMessage = {};

openBidsStyles.customerInfoContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 32px;
        margin-bottom: 12px;
        ${hideElementOnPrint}
        ${xScreen("lte", "md")} {
            flex-direction: column;
            row-gap: 8px;
        }
    `,
};

openBidsStyles.dataTable = {
    ...dataTableStyles.dataTable,
};

openBidsStyles.customerInfo = {
    size: 14,
    lineHeight: "22px",
};

openBidsStyles.printBidsLink = {
    typographyProps: {
        size: 12,
        lineHeight: "15px",
    },
    icon: {
        position: "left",
        iconProps: {
            src: Printer,
            size: 14,
            css: css`
                margin-right: 6px;
                opacity: 0.66;
            `,
        },
    },
    css: css`
        flex: 1;
        justify-content: end;
    `,
};
